import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { MemberService } from '@app/services/member.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { SortService } from '@app/components/sorting/SortService';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-addmembership',
  templateUrl: './addmembership.component.html'
})

export class AddmembershipComponent implements OnInit, OnDestroy {
  @Input() memberid: number;
  @Input() givenname: string;
  @Input() familyname: string;
  @Output() closeAdd: EventEmitter<any> = new EventEmitter();
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  institutions;
  subscriptions: Subscription[] = [];
  addmembershipform;
  

  constructor(
    private fb: FormBuilder,
    private snackbarService: SnackbarService,
    private memberService: MemberService,
    private institutionsService: InstitutionsService) { }

  ngOnInit() {
    this.addmembershipform = this.fb.group({
      memberId: ['', ''],
      institutionId: ['', Validators.required],
      startDate: ['', Validators.required],
      action: ['add', '']
    });
    this.addmembershipform.get('memberId').setValue(this.memberid.toString());
    this.subscriptions.push(this.institutionsService.GetAllInstitutionsExceptLodges(0).subscribe(response => {
      if (response) {
        this.institutions = response.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  save() {
    const addmembershiparr = [];
    const data = {
      memberId: this.addmembershipform.get('memberId').value,
      institutionId: Number(this.addmembershipform.get('institutionId').value),
      startDate: this.addmembershipform.get('startDate').value,
      action: 'add'
    };
    addmembershiparr.push(data);
    this.subscriptions.push(this.memberService.updateMemberMembership(addmembershiparr).subscribe(response => {
      if (response) {
        if (response[0].status === 'ok') {
          this.snackbarService.openSnackBar('Medlemskapet tillagt', null);
        } else {
          this.snackbarService.openSnackBar(response[0].status, null);
        }
        this.closeAdd.emit();
      }
    }));
  }

  close() {
    this.closeAdd.emit();
  }
}
